import { call, put } from "redux-saga/effects";
import { notification } from "antd";
import { Creators as StockMovementActions } from "../ducks/stockMovement";
import {
  callStockMovementIndex,
  callStockMovementShow,
  callStockMovementSave,
  callStockMovementRequestDelete,
} from "../../services/stockMovementService";

export function* indexStockMovement(action) {
  try {
    const { data } = yield call(callStockMovementIndex, action.payload);
    const { page, size, sorter, filters } = action.payload;
    yield put(
      StockMovementActions.indexStockMovementSuccess(data.results || data, {
        total: data.total || 0,
        page,
        size,
        sorter,
        filters,
      }),
    );
  } catch (error) {
    yield put(StockMovementActions.indexStockMovementError(error));
  }
}

export function* showStockMovement(action) {
  try {
    const { data } = yield call(callStockMovementShow, action.payload);
    yield put(
      StockMovementActions.showStockMovementSuccess(data.results || data),
    );
  } catch (error) {
    yield put(StockMovementActions.showStockMovementError(error));
  }
}

export function* saveStockMovement(action) {
  try {
    // O payload pode conter múltiplas linhas (uma NF com vários itens). O
    // backend persiste o movimento + atualiza saldo + gera contabilidade e
    // define o status numa única transação. O front apenas envia.
    yield call(callStockMovementSave, action.payload);
    yield put(StockMovementActions.saveStockMovementSuccess());
    notification.success({ message: "Movimento(s) salvo(s) com sucesso!" });
    yield put(
      StockMovementActions.indexStockMovement(
        action.payload.groupId,
        action.payload.farmId,
      ),
    );
  } catch (error) {
    if (Object.keys(error).includes("response")) {
      const { response } = error;
      if (Object.keys(response).includes("data")) {
        const {
          data: { code: errorCode },
        } = response;
        if (errorCode === 5045) {
          notification.error({
            message:
              "Erro ao salvar movimento. N° de Documento NF-e duplicado.",
          });
        } else {
          notification.error({ message: "Erro ao salvar movimento." });
        }
      }
    } else {
      notification.error({ message: "Erro ao salvar movimento." });
    }
    yield put(StockMovementActions.saveStockMovementError(error));
  }
}

export function* requestDeleteStockMovement(action) {
  try {
    yield call(callStockMovementRequestDelete, action.payload);
    yield put(StockMovementActions.requestDeleteStockMovementSuccess());
    notification.info({
      message: "Solicitação de exclusão enviada para auditoria.",
    });
    yield put(
      StockMovementActions.indexStockMovement(
        action.payload.groupId,
        action.payload.farmId,
      ),
    );
  } catch (error) {
    notification.error({ message: "Erro ao solicitar exclusão do movimento." });
    yield put(StockMovementActions.requestDeleteStockMovementError(error));
  }
}
